import { useBaseApiMutation } from "@mutation/baseMutation";

export const useReservationSearchMutation = () =>{

    return useBaseApiMutation(
        {
            method: "GET",
            endpoint: `/organization/me/reservation/code/{reservation_code}`
        }
    )
}


export const useReservationCancelMutation = () =>{

    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: `/organization/me/reservation/{reservation_uuid}/cancel`
        }
    )
}


export const useReservationAcceptMutation = () =>{

    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: `/organization/me/reservation/{reservation_uuid}/accept`
        }
    )
}
